import script from "./DeparturesBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeparturesBoard.vue?vue&type=script&setup=true&lang=ts"

import "./DeparturesBoard.vue?vue&type=style&index=0&id=144496d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-144496d0"]])

export default __exports__